module.exports = __webpack_public_path__ + "img/link-icon-hi.65f0e95f.svg";